import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Button, Stack} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useTranslation from "../hooks/translations";

export default function SortableItem({
                                       row,
                                       columns,
                                       editAction,
                                       deleteAction
                                     }) {
  const translations = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({id: row.id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr key={row.id} ref={setNodeRef}
        style={style}>
      {columns.map((column, index) => (
        <td key={index}>{row[column.data_identifier]}</td>
      ))}
      {(editAction || deleteAction) &&
        <td>
          <Stack direction="horizontal" gap={3}>
            <Button variant="link" {...attributes} {...listeners}>
              <FontAwesomeIcon icon="sort"
                               className="me-1"/>
            </Button>
            {
              editAction &&
              <Button variant="primary"
                      size="sm"
                      onClick={() => {
                        editAction(row);
                      }
                      }>
                <FontAwesomeIcon icon="edit"
                                 className="me-1"/>
                {translations.edit}
              </Button>
            }
            {
              deleteAction &&
              <Button variant="danger"
                      size="sm"
                      onClick={() => {
                        deleteAction(row);
                      }}>
                <FontAwesomeIcon icon="trash"
                                 className="me-1"/>
                {translations.delete}
              </Button>
            }
          </Stack>
        </td>}
    </tr>
  );
}
